var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shrink"},[_c('q-input',{ref:"timer",style:(_vm.stl),attrs:{"dense":true,"onfocus":"this.select();"},on:{"keypress":_vm.filterForValidation,"keyup":_vm.filterFordot},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }